"use strict";
var ɵngcc0 = require('@angular/core');
var ɵngcc1 = require('@angular/common/http');
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var http_1 = require("@angular/common/http");
var operators_1 = require("rxjs/operators");
var deliverables_shared_service_1 = require("../deliverables-shared.service");
var deliverable_client_config_1 = require("../../deliverable.client.config");
var helpers_1 = require("../../helpers");
var i0 = require("@angular/core");
var i1 = require("@angular/common/http");
var i2 = require("../../deliverable.client.config");
var PublishService = /** @class */ (function () {
    /**
     * Initialises a new instance of the ContractService /> class.
     * @param http
     * @param config
     */
    function PublishService(http, config) {
        this.http = http;
        this.config = config;
    }
    /**
      * Add Manual Message
      * @param publishId
      * @param messageRequest
      * @returns An Observable containing the IDeliverableFeatureEditable
      */
    PublishService.prototype.AddMessage = function (publishId, messageRequest) {
        return this.http.put(this.config.DeliverablesApiURL + "/api/publish/" + publishId + "/addmessage", messageRequest)
            .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
       * Adjust Term.
       * @param adjustDeliverableTermRequest
       * @returns An Observable containing the DeliverableBase
       */
    PublishService.prototype.AdjustTerm = function (adjustDeliverableTermRequest) {
        return this.http.put(this.config.DeliverablesApiURL + "/api/publish/adjustterm", adjustDeliverableTermRequest)
            .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
    * Assign Task.
    * @param publishTaskId
    * @param assignTaskRequest
    * @returns An Observable containing the IDeliverableFeatureEditable
    */
    PublishService.prototype.AssignTask = function (publishTaskId, assignTaskRequest) {
        return this.http.put(this.config.DeliverablesApiURL + "/api/publish/" + publishTaskId + "/assign", assignTaskRequest)
            .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
    * Delete.
    * @param publishId
    * @param operatorId
    * @returns An Observable containing boolean
    */
    PublishService.prototype.Delete = function (publishId, operatorId) {
        return this.http.delete(this.config.DeliverablesApiURL + "/api/publish/" + publishId + "/" + operatorId)
            .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * Get.
     * @param id
     * @param allDescendants
     * @param immediateChildren
     * @returns An Observable containing the SimpleDContract
     */
    PublishService.prototype.Get = function (id) {
        var params = new http_1.HttpParams();
        return this.http.get(this.config.DeliverablesApiURL + "/api/publish/" + id, { params: params })
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * List Async.
     * @param page
     * @param pageSize
     * @param feedId
     * @returns An Observable containing the model.IPagedList<DeliverableTopReadOnly>
     */
    PublishService.prototype.List = function (page, pageSize, feedId, ownerIds, workStatusTypes, contractTypeIds, fromDate, toDate, orderByCriteria, businessUnits, accountId) {
        if (page === void 0) { page = 1; }
        if (pageSize === void 0) { pageSize = 10; }
        var params = new http_1.HttpParams();
        if (page)
            params = params.set('page', page.toString());
        if (pageSize)
            params = params.set('pageSize', pageSize.toString());
        if (feedId)
            params = params.set('feedId', feedId.toString());
        if (ownerIds)
            params = params.set('ownerIds', ownerIds);
        if (workStatusTypes)
            params = params.set('workStatusTypes', workStatusTypes);
        if (contractTypeIds)
            params = params.set('contractTypeIds', contractTypeIds);
        if (fromDate)
            params = params.set('fromDate', fromDate);
        if (toDate)
            params = params.set('toDate', toDate);
        if (orderByCriteria)
            params = params.set('orderByCriteria', orderByCriteria);
        if (businessUnits)
            params = params.set('businessUnits', businessUnits);
        if (accountId)
            params = params.set('accountId', accountId.toString());
        return this.http.get(this.config.DeliverablesApiURL + "/api/publish/", { params: params })
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
  * Lock A publish task term.
  * @param lockTaskRequest
  * @returns An Observable containing a boolean
  */
    PublishService.prototype.LockTask = function (publishTaskId, lockTaskRequest) {
        return this.http.put(this.config.DeliverablesApiURL + "/api/publish/" + publishTaskId + "/lock", lockTaskRequest)
            .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * Remove a publish task
     * @param publishTaskId
     * @param removeTaskRequest
     * @returns An Observable containing the DeliverableChildBase
     */
    PublishService.prototype.RemoveTask = function (publishTaskId, removeTaskRequest) {
        return this.http.post(this.config.DeliverablesApiURL + "/api/publish/" + publishTaskId + "/removetask", removeTaskRequest)
            .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
      * Put.
      * @param id
      * @param renamePublishRequest
      * @returns An Observable containing the DeliverableChildBase
      */
    PublishService.prototype.Rename = function (id, renamePublishRequest) {
        return this.http.put(this.config.DeliverablesApiURL + "/api/publish/" + id, renamePublishRequest)
            .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
      * Rename a publish task
      * @param id
      * @param renamePublishRequest
      * @returns An Observable containing the DeliverableChildBase
      */
    PublishService.prototype.RenameTask = function (publishTaskId, renamePublishRequest) {
        return this.http.put(this.config.DeliverablesApiURL + "/api/publish/" + publishTaskId + "/renametask", renamePublishRequest)
            .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
  * Reset a publish task.
  * @param resetPublishRequest
  * @returns An Observable containing a boolean
  */
    PublishService.prototype.ResetTask = function (publishTaskId, resetPublishRequest) {
        return this.http.post(this.config.DeliverablesApiURL + "/api/publish/" + publishTaskId + "/reset", resetPublishRequest)
            .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
    * Transfer Owner.
    * @param publishId
    * @param transferOwnerRequest
    * @returns An Observable containing the IDeliverableFeatureEditable
    */
    PublishService.prototype.ChangeOwner = function (publishId, changeOwnerRequest) {
        return this.http.put(this.config.DeliverablesApiURL + "/api/publish/" + publishId + "/changeowner", changeOwnerRequest)
            .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * Publish to the content-library
     * @param publishTaskId
     * @param publishRequest
     */
    PublishService.prototype.PublishContentLibrary = function (publishTaskId, publishRequest) {
        return this.http.post(this.config.DeliverablesApiURL + "/api/publish/" + publishTaskId + "/publish-content-library", publishRequest)
            .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * RePublish to the content-library
     * @param publishTaskId
     * @param rePublishRequest
     */
    PublishService.prototype.RePubilshContentLibrary = function (publishTaskId, rePublishRequest) {
        return this.http.post(this.config.DeliverablesApiURL + "/api/publish/" + publishTaskId + "/republish-content-library", rePublishRequest)
            .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    PublishService.ngInjectableDef = i0.defineInjectable({ factory: function PublishService_Factory() { return new PublishService(i0.inject(i1.HttpClient), i0.inject(i2.DELIVERABLE_CLIENT_CONFIG)); }, token: PublishService, providedIn: "root" });
    PublishService = __decorate([ __param(1, core_1.Inject(deliverable_client_config_1.DELIVERABLE_CLIENT_CONFIG)),
        __metadata("design:paramtypes", [http_1.HttpClient, Object])
    ], PublishService);
PublishService.ɵfac = function PublishService_Factory(t) { return new (t || PublishService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(deliverable_client_config_1.DELIVERABLE_CLIENT_CONFIG)); };
PublishService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: PublishService, factory: function (t) { return PublishService.ɵfac(t); }, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PublishService, [{
        type: core_1.Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: Object, decorators: [{
                type: core_1.Inject,
                args: [deliverable_client_config_1.DELIVERABLE_CLIENT_CONFIG]
            }] }]; }, null); })();
    return PublishService;
}());
exports.PublishService = PublishService;

